import { useQuery } from '@tanstack/react-query'
import InsightsAPI from '@/features/dashboard/api/insights/InsightsAPI'
import { QUERY } from '@/features/dashboard/api/insights/InsightsAPI.model'

interface ToppingsQueryProps {
  first_start_date: string
  first_end_date: string
  second_start_date: string
  second_end_date: string
}

export function useToppingsInsightsQuery(props: ToppingsQueryProps) {
  const {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date
  } = props

  const params = {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date
  }

  const totalSalesValueToppings = useQuery({
    queryKey: [QUERY.TOTAL_SALES_VALUE_TOPPINGS, params],
    queryFn: () => InsightsAPI.getTotalSalesValueToppings(params)
  }).data

  const totalSalesCountToppings = useQuery({
    queryKey: [QUERY.TOTAL_SALES_COUNT_TOPPINGS, params],
    queryFn: () => InsightsAPI.getTotalSalesCountToppings(params)
  }).data

  const totalSalesAveragesToppings = useQuery({
    queryKey: [QUERY.TOTAL_SALES_AVERAGES_TOPPINGS, params],
    queryFn: () => InsightsAPI.getTotalSalesAveragesToppings(params)
  }).data

  const totalSalesCumulativeValueToppings = useQuery({
    queryKey: [QUERY.TOTAL_SALES_CUMULATIVE_VALUE_TOPPINGS, params],
    queryFn: () => InsightsAPI.getTotalSalesCumulativeValueToppings(params)
  }).data

  return {
    totalSalesValueToppings,
    totalSalesCountToppings,
    totalSalesAveragesToppings,
    totalSalesCumulativeValueToppings
  }
}
